import { toast as vdToast } from "@vd/ui";

export { Toaster } from "@vd/ui";

/** Short confirmation or error. Danger toasts stay until dismissed. */
export function toast(text: string, tone: "ok" | "danger" | "info" = "ok"): void {
  if (tone === "ok") vdToast.success(text);
  else if (tone === "danger") vdToast.danger(text);
  else vdToast({ title: text, tone: "neutral" });
}
